import React from 'react'
import { ModalFormButton } from '../../../../../components/ModalFormButton'
import { NoPaymentsPlaceholder } from '../Payments'
import TransfersHistoryTimeline from './TransfersHistoryTimeline'

export function TransfersDetailsButton({
  policy,
  paymentMethod,
  customer,
  ...rest
}) {
  function onClose() {}

  function onSubmit(formData) {}

  const transfersForPaymentMethod =
    policy.paymentHistory.paymentTransfers.filter(
      el => el.paymentMethodId === paymentMethod.id
    )

  return (
    <ModalFormButton
      onClose={onClose}
      onSubmit={onSubmit}
      submitDisabled={true}
      fullWidth
      titleLabel={`Überweisungen (Police: ${policy.id}, Externe Id: ${policy.externalId})`}
      buttonLabel={'Überweisungen'}
      {...rest}
      formContent={
        <div>
          {transfersForPaymentMethod && transfersForPaymentMethod.length > 0 ? (
            <TransfersHistoryTimeline
              transfers={transfersForPaymentMethod.reverse()}
              paymentMethod={paymentMethod}
              policy={policy}
            />
          ) : (
            <NoPaymentsPlaceholder />
          )}
        </div>
      }
    />
  )
}
